const FederateConfig = {
    CLIENT_ID: "voldemort",
    REDIRECT_URI: window.location.protocol + "//" + window.location.host + "/",
    AUTH_URL: "https://idp.federate.amazon.com/api/oauth2/v1/authorize",
    TOKEN_URL: "https://idp.federate.amazon.com/api/oauth2/v2/token",
};

export const getFederateConfig = () => FederateConfig;
